(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.mccFidelityReady === 'true') return;
    root.dataset.mccFidelityReady = 'true';

    var benefitCards = Array.prototype.slice.call(root.querySelectorAll('[data-mcc-benefit-card]'));
    benefitCards.forEach(function (card) {
      card.querySelectorAll('[data-mcc-benefit-toggle]').forEach(function (button) {
        button.addEventListener('click', function () {
          var willOpen = !card.classList.contains('is-open');
          benefitCards.forEach(function (other) {
            other.classList.remove('is-open');
            var front = other.querySelector('.mcc-benefit-fidelity__front');
            if (front) front.setAttribute('aria-expanded', 'false');
          });
          if (willOpen) {
            card.classList.add('is-open');
            var cardFront = card.querySelector('.mcc-benefit-fidelity__front');
            if (cardFront) cardFront.setAttribute('aria-expanded', 'true');
          }
        });
      });
    });

    var journey = root.querySelector('[data-mcc-journey]');
    if (journey) {
      var steps = journey.querySelector('.mcc-wj__steps');
      var fill = journey.querySelector('[data-mcc-journey-fill]');
      var dots = Array.prototype.slice.call(journey.querySelectorAll('[data-mcc-journey-dot]'));
      var journeyTicking = false;
      function updateJourney() {
        journeyTicking = false;
        if (!steps || !fill) return;
        var rect = steps.getBoundingClientRect();
        var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
        var progress = Math.max(0, Math.min((viewportHeight * 0.7 - rect.top) / Math.max(rect.height, 1), 1));
        fill.style.height = (progress * 100).toFixed(1) + '%';
        var fillPixels = progress * rect.height;
        dots.forEach(function (dot) {
          var dotCenter = dot.offsetTop + dot.offsetHeight / 2;
          dot.classList.toggle('is-active', fillPixels >= dotCenter);
        });
      }
      function requestJourneyUpdate() {
        if (journeyTicking) return;
        journeyTicking = true;
        requestAnimationFrame(updateJourney);
      }
      window.addEventListener('scroll', requestJourneyUpdate, { passive: true });
      window.addEventListener('resize', requestJourneyUpdate);
      updateJourney();
    }

    function perView(carousel) {
      var type = carousel.dataset.mccCarousel;
      if (type === 'reasons') {
        if (window.innerWidth <= 767) return 1;
        if (window.innerWidth <= 900) return 2;
        return 3;
      }
      return window.innerWidth <= 767 ? 3 : 3;
    }

    root.querySelectorAll('[data-mcc-carousel]').forEach(function (carousel) {
      var track = carousel.querySelector('[data-mcc-carousel-track]');
      if (!track) return;
      var slides = Array.prototype.slice.call(track.children);
      var dots = carousel.querySelector('[data-mcc-carousel-dots]');
      var previous = carousel.querySelector('[data-mcc-carousel-prev]');
      var next = carousel.querySelector('[data-mcc-carousel-next]');
      var index = 0;
      var startX = 0;

      function maxIndex() {
        return Math.max(slides.length - perView(carousel), 0);
      }
      function renderDots() {
        if (!dots) return;
        dots.innerHTML = '';
        for (var i = 0; i <= maxIndex(); i += 1) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.dataset.index = String(i);
          dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
          dot.addEventListener('click', function () { goTo(Number(this.dataset.index)); });
          dots.appendChild(dot);
        }
      }
      function goTo(nextIndex) {
        index = Math.max(0, Math.min(nextIndex, maxIndex()));
        var firstOffset = slides[0] ? slides[0].offsetLeft : 0;
        var targetOffset = slides[index] ? slides[index].offsetLeft - firstOffset : 0;
        track.style.transform = 'translate3d(' + (-targetOffset) + 'px,0,0)';
        if (dots) {
          dots.querySelectorAll('button').forEach(function (dot, dotIndex) {
            dot.classList.toggle('is-active', dotIndex === index);
            if (dotIndex === index) dot.setAttribute('aria-current', 'true');
            else dot.removeAttribute('aria-current');
          });
        }
        if (previous) previous.disabled = index === 0;
        if (next) next.disabled = index === maxIndex();
      }
      if (previous) previous.addEventListener('click', function () { goTo(index - 1); });
      if (next) next.addEventListener('click', function () { goTo(index + 1); });
      track.addEventListener('touchstart', function (event) { startX = event.changedTouches[0].clientX; }, { passive: true });
      track.addEventListener('touchend', function (event) {
        var distance = startX - event.changedTouches[0].clientX;
        if (Math.abs(distance) > 45) goTo(index + (distance > 0 ? 1 : -1));
      }, { passive: true });
      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () { renderDots(); goTo(Math.min(index, maxIndex())); }, 160);
      });
      renderDots();
      goTo(0);
    });

    var videoCards = Array.prototype.slice.call(root.querySelectorAll('[data-mcc-video-card]'));
    function stopOtherVideos(activeCard) {
      videoCards.forEach(function (card) {
        if (card === activeCard) return;
        var video = card.querySelector('video');
        if (video) {
          video.pause();
          video.currentTime = 0;
          video.muted = true;
        }
        card.classList.remove('is-playing', 'is-paused');
        var mute = card.querySelector('[data-mcc-video-mute]');
        if (mute) mute.hidden = true;
      });
    }
    videoCards.forEach(function (card) {
      var video = card.querySelector('video');
      var play = card.querySelector('[data-mcc-video-play]');
      var mute = card.querySelector('[data-mcc-video-mute]');
      if (!video || !play || !mute) return;
      function updateMute() {
        mute.textContent = video.muted ? '🔇' : '🔊';
        mute.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
      }
      function startVideo() {
        stopOtherVideos(card);
        card.classList.add('is-playing');
        card.classList.remove('is-paused');
        mute.hidden = false;
        video.muted = false;
        updateMute();
        video.play().catch(function () {
          video.muted = true;
          updateMute();
          video.play().catch(function () {});
        });
      }
      play.addEventListener('click', function () {
        if (!card.classList.contains('is-playing') || video.paused) startVideo();
        else {
          video.pause();
          card.classList.add('is-paused');
        }
      });
      video.addEventListener('click', function () {
        if (video.paused) {
          video.play();
          card.classList.remove('is-paused');
        } else {
          video.pause();
          card.classList.add('is-paused');
        }
      });
      video.addEventListener('play', function () { card.classList.remove('is-paused'); });
      mute.addEventListener('click', function (event) {
        event.stopPropagation();
        video.muted = !video.muted;
        updateMute();
      });
      updateMute();
    });

    if ('IntersectionObserver' in window) {
      var videosSection = root.querySelector('.mcc-video-fidelity');
      if (videosSection) {
        new IntersectionObserver(function (entries) {
          if (entries[0].isIntersecting) return;
          videoCards.forEach(function (card) {
            var video = card.querySelector('video');
            if (video && !video.paused) {
              video.pause();
              card.classList.add('is-paused');
            }
          });
        }, { threshold: 0.05 }).observe(videosSection);
      }
    }
  }

  function boot() {
    document.querySelectorAll('[data-mcc-root]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
